import * as React from 'react'
// context
import { RiskTableContext } from 'containers/Risks/RiskTable/layers/BL'

export const useCurrentTable = () => {
  return React.useContext(RiskTableContext)
}
